export default "__VITE_ASSET__Cr3KsQo0__"